import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/button';
import { Check, Shield, Zap, Clock } from 'lucide-react';

const features = [
  { icon: Clock, text: '24/7 Coverage' },
  { icon: Zap, text: 'Full CRM Integration' },
  { icon: Check, text: 'Custom Scripting for Your Services' },
  { icon: Shield, text: '30-Day "More Leads" Guarantee' }
];

export const PricingOffer = ({ onOpenQuiz }) => {
  return (
    <section id="pricing" className="py-24 sm:py-32 bg-[#050505]">
      <div className="max-w-5xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl sm:text-5xl font-headline font-bold text-[#F4F4F5] mb-4">
            Costs less than a <span className="gradient-text">tank of diesel.</span>
          </h2>
          <p className="text-lg text-[#A1A1AA] font-body max-w-3xl mx-auto">
            No long-term contracts. No "per-user" fees. Just an AI employee that pays for itself with the first job it saves.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="glass p-10 sm:p-12 rounded-2xl max-w-3xl mx-auto"
        >
          <div className="grid sm:grid-cols-2 gap-6 mb-10">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="flex items-center gap-3"
              >
                <feature.icon className="w-6 h-6 text-[#00E599] flex-shrink-0" />
                <span className="text-[#F4F4F5] font-body font-medium">{feature.text}</span>
              </motion.div>
            ))}
          </div>

          <div className="text-center space-y-6">
            <div>
              <p className="text-sm text-[#A1A1AA] font-accent uppercase tracking-wider mb-2">Starting at</p>
              <p className="text-6xl font-headline font-bold gradient-text mb-2">$297</p>
              <p className="text-xl text-[#A1A1AA]">per month</p>
            </div>

            <Button
              onClick={onOpenQuiz}
              size="lg"
              className="w-full bg-[#00E599] hover:bg-[#00C985] text-[#050505] whitespace-nowrap px-4 sm:px-10 py-5 sm:py-6 text-sm sm:text-xl font-body font-bold transition-all duration-300 hover:shadow-2xl hover:shadow-[#00E599]/40 rounded-xl"
            >
              Get Started Today
            </Button>

            <p className="text-sm text-[#A1A1AA] font-body italic">
              No credit card required to see the demo. Cancel anytime.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default PricingOffer;
